import { callApi } from '@local_modules/generic/fetch.js'

//
export async function loadCurrencies (appAccountId) {
  const apiUrl = '/currencies/view/currency-list-account/:appAccountId'
  const data = await callApi(apiUrl, {
    appAccountId
  })
  // console.log(data)

  return data
}
